import React from 'react';

import UploadButton from 'src/components/UploadButton';
import TooltipWrapper from 'src/components/TooltipWrapper';

const MAX_FILE_NAME_LENGTH = 30;

interface UploadAndDeleteButtonProps {
    testid?: string;
    className?: string;
    fileName?: string;
    hidden?: boolean;
    disabled?: boolean;
    onHide?(...args: unknown[]): unknown;
    onDelete?(...args: unknown[]): unknown;
    onDownload?(): void;
    onUpload: React.ChangeEventHandler<HTMLInputElement>;
}

const UploadAndDeleteButton: React.FC<UploadAndDeleteButtonProps> = (props) => {
    const { fileName, onDelete, onHide, onDownload, hidden, testid } = props;
    return (
        <div className={`upload-and-delete ${props.className || ''}`}>
            <UploadButton testid={testid} {...props} />
            {fileName && (
                <>
                    <div className='upload-and-delete__file-name'>
                        <TooltipWrapper contents={fileName}>
                            <span>
                                {fileName.length > MAX_FILE_NAME_LENGTH
                                    ? `${fileName.slice(0, MAX_FILE_NAME_LENGTH)}…`
                                    : fileName}
                            </span>
                        </TooltipWrapper>
                    </div>
                    {onDownload && (
                        <button className='upload-and-delete__download' onClick={onDownload}>
                            <img className='iconLg' src='https://static.ux.cimpress.io/assets/icons/download-3-l.svg' />
                        </button>
                    )}
                    {onHide && (
                        <button className='upload-and-delete__hide' onClick={onHide}>
                            <img
                                className={`iconLg ${hidden ? '' : 'colorOceanBase'}`}
                                src='https://static.ux.cimpress.io/assets/icons/view-2-l.svg'
                            />
                        </button>
                    )}
                    {onDelete && (
                        <button className='upload-and-delete__delete' onClick={onDelete}>
                            <img className='iconLg' src='https://static.ux.cimpress.io/assets/icons/bin-1-l.svg' />
                        </button>
                    )}
                </>
            )}
        </div>
    );
};

export default React.memo(UploadAndDeleteButton);
